// Color legend component for Scheduler

import { useRef, useState, useLayoutEffect } from 'react';
import PropItem from './PropItem';
import Tooltip from './Tooltip';
import { useFirebase } from './FirebaseContextProvider';
import { getTeamDivision } from '../utils/misc';
import { gameDivision } from '../utils/gameReport';
import { GameTypes } from '../utils/enums';
import './ColorLegend.scss';

function TruncatedName({ name }) {
  const ref = useRef(null);
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) setTruncated(el.scrollWidth > el.offsetWidth);
  }, [name]);

  const p = (
    <p ref={ref} className='division-name'>
      {name},
    </p>
  );
  return truncated ? <Tooltip label={name}>{p}</Tooltip> : p;
}

export default function ColorLegend({ id, colorLegend }) {
  const { tournamentsById, teamsById } = useFirebase();
  const tournament = tournamentsById.get(id);
  const { games } = tournament;

  return (
    <ul className='color-legend'>
      {Object.entries(colorLegend).map(([divisionName, payload]) => {
        const { color } = payload;

        const teamsNum = tournament.teams
          .filter((t) => t.admitted)
          .filter(
            (t) => getTeamDivision(teamsById.get(t.id)) === divisionName,
          ).length;

        const playoffs = games.filter(
          (g) => g.type === GameTypes.PLAYOFF && g.division === divisionName,
        ).length;

        const pools = games.filter(
          (g) =>
            g.type === GameTypes.POOLGAME &&
            gameDivision(g, teamsById) === divisionName,
        ).length;

        return (
          <li key={divisionName} style={{ borderLeftColor: color }}>
            <div className='top'>
              <TruncatedName name={divisionName} />
            </div>
            <div className='count'>
              <PropItem prop='Teams' value={teamsNum + ','} />
              <PropItem prop='Pool' value={pools + ','} />
              <PropItem prop='PO' value={playoffs} />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
